$(function () {
    var $body = $('body');

    $('.fee-free').on('click', function(e) {
      e.preventDefault();
  
      $('#feeFree').modal();
    });

    $('.job-trainer').on('click', function(e) {
      e.preventDefault();
  
      $('#jobTrainer').modal();
    });
});